import { useContext, useState } from "react"
import { VehicleDA_SaveContext } from "../VehicleDA_SelectVehicle"

const VehicleDA_DriverPerVehicle = ({ drivers }) => {
    const da_saveContext = useContext(VehicleDA_SaveContext)
    var vehicles = da_saveContext?.vehicles
    var vehicleIndex = da_saveContext?.vehicleIndex

    // Checks selected drivers for other vehicles to disable radio button
    const checkVehicleSelected = (driver) => {
        for (var i = 0; i < vehicles.length; i++) {
            if (vehicles?.length < drivers?.length || vehicles?.length == drivers?.length) {
                if (driver == vehicles[i]?.driverName) {
                    return true
                }
            }
        }
        return false
    }

    // Checks selected vehicle type for drivers to disable radio button
    const checkPrimaryOccasionalSelected = (driverName) => {
        return vehicles?.some(vehicle => vehicle?.vehicleType == "Primary" && vehicle?.driverName == driverName);
    }

    // Updates the values
    const handleChange = (key, value, vehicleIndex) => {
        // Logic for handling dob input
        if (key == "driverDOB") {
            value = value.replace(/\D/g, '');
            if (value.length > 2) {
                value = `${value.slice(0, 2)}/${value.slice(2)}`;
            }
            if (value.length > 5) {
                value = `${value.slice(0, 5)}/${value.slice(5)}`;
            }
            if (value.length === 10) {
                const [month, day, year] = value.split('/');
                const enteredDate = new Date(`${year}-${month}-${day}`);
                const today = new Date();

                if (enteredDate > today) {
                    const todayStr = today.toISOString().slice(0, 10).split('-');
                    value = `${todayStr[1]}/${todayStr[2]}/${todayStr[0]}`;
                }
            }
            da_saveContext.setDob(value);
        }
        da_saveContext.handleSingleField(key, value, vehicleIndex)
    };

    // Removes the slash when deleting
    const handleKeyDown = (e) => {
        if (e.key === 'Backspace') {
            const value = e.target.value;
            if (value.endsWith('/')) {
                e.preventDefault();
                da_saveContext.setDob(value.slice(0, -1));
            }
        }
    };

    return (
        <>
            {drivers?.length > 0 &&
                <>
                    {/* Driver selection for each vehicle */}
                    {drivers?.map((driver, index) => {
                        var driverName = driver.fullName
                        return (
                            <div key={index}>
                                <div className="radio m-1">
                                    <label className="form-check-label">
                                        <input className="form-check-input" name={vehicleIndex} type={"radio"}
                                            value={driver}
                                            onChange={() => { da_saveContext.saveDriverToVehicle(vehicleIndex, driver) }}
                                            checked={vehicles[vehicleIndex]?.driverName == driverName}
                                            disabled={checkVehicleSelected(driverName)}
                                        />
                                        <span className="m-2">{driverName}</span>
                                    </label>
                                </div>

                                {/* Display primary vs occasional IF vehicles > drivers */}
                                {vehicles?.length > drivers?.length && vehicles[vehicleIndex].driverName == driverName &&
                                    <>
                                        {["Primary", "Occasional"].map((vehicleType, index) => (
                                            <div className="radio mx-5 my-2" key={index}>
                                                <label className="form-check-label">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        value={vehicleType}
                                                        onChange={() => { da_saveContext.handleSingleField("vehicleType", vehicleType, vehicleIndex) }}
                                                        checked={vehicles[vehicleIndex]?.vehicleType == vehicleType}
                                                        disabled={vehicleType == "Primary" ? checkPrimaryOccasionalSelected(driverName) : false}
                                                        />
                                                    <span className="m-2">{vehicleType} Vehicle</span>
                                                </label>
                                            </div>
                                        ))}
                                    </>
                                }
                            </div>
                        )
                    })}

                    {/* Other Driver Option */}
                    <div className="radio m-1">
                        <label className="form-check-label">
                            <input className="form-check-input" name={vehicleIndex} type={"radio"}
                                value={"OtherDriver"}
                                onChange={(e) => { da_saveContext.saveDriverToVehicle(vehicleIndex, e.target.value) }}
                                checked={vehicles[vehicleIndex]?.otherDriverSelected == "Yes"}
                            />
                            <span className="m-2">Other Driver</span>
                        </label>
                    </div>

                    {/* Other Driver Fields */}
                    {vehicles[vehicleIndex]?.otherDriverSelected == "Yes" &&
                        <div className="m-1">
                            {/* Full Name */}
                            <div className="col-12 form-check-label my-2">
                                <span className="mx-4">Driver's First and Last Name:*</span>
                                <div className="col-10 col-sm-6">
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        className="form-control mx-4"
                                        placeholder="Full Name"
                                        value={vehicles[vehicleIndex]?.driverName ? vehicles[vehicleIndex]?.driverName : ""}
                                        onChange={(e) => handleChange("driverName", e.target.value, vehicleIndex)}
                                        style={{ fontSize: "15px" }}
                                    />
                                </div>
                            </div>

                            {/* DOB */}
                            <div className="col-12 form-check-label my-2">
                                <span className="mx-4">Driver's Date of Birth:*</span>
                                <div className="col-10 col-sm-6">
                                    <input
                                        type="text"
                                        className="form-control mx-4"
                                        placeholder="DOB (mm/dd/yyyy)"
                                        value={vehicles[vehicleIndex]?.driverDOB ? vehicles[vehicleIndex]?.driverDOB : ""}
                                        onChange={(e) => handleChange("driverDOB", e.target.value, vehicleIndex)}
                                        onKeyDown={handleKeyDown}
                                        maxLength={10}
                                        style={{ fontSize: "15px" }}
                                    />
                                </div>
                            </div>


                            {/* License Number */}
                            <div className="col-12 form-check-label my-2">
                                <span className="mx-4">Driver's License Number:*</span>
                                <div className="col-10 col-sm-6">
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        className="form-control mx-4"
                                        placeholder="License Number"
                                        value={vehicles[vehicleIndex]?.driverDLN ? vehicles[vehicleIndex]?.driverDLN : ""}
                                        onChange={(e) => handleChange("driverDLN", e.target.value, vehicleIndex)}
                                        style={{ fontSize: "15px" }}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                </>
            }
            {drivers?.length === 0 &&
                <p>Found no drivers</p>
            }
        </>
    )
}

export default VehicleDA_DriverPerVehicle